// extracted by mini-css-extract-plugin
export default {"tableRow":"BodyTable_tableRow__ePbXh","cardName":"BodyTable_cardName__r6CPR"};